/**
 * Created by intellicar-rinas on 4/1/18.
 */
import React, {Component} from 'react';
import './CompactorView.css';
import Dom from '../../../../helpers/Dom';

class CompactorView extends Component {

    state = {stats:{}, can2:{}, vehicle:{}}

    constructor(){
        super();

        this.updateView =()=> {
            if(this.props && this.props.vehicle) {
                this.setState({can2:{...this.props.vehicle().can2}, stats:{...this.props.vehicle().stats}, vehicle:{...this.props.vehicle()}});
            }
            this.forceUpdate();
        };

        this.isSimulating =()=> {
            return window.getMQTTSimulationStatus ? window.getMQTTSimulationStatus() : false;
        };

        this.toggleSimulation =()=> {
            if(window.getMQTTSimulationStatus) {
                let status = window.getMQTTSimulationStatus();
                if(status) {
                    window.stopMQTTSimulation()
                } else {
                    window.startMQTTSimulation()
                }
                setTimeout(()=>this.forceUpdate(), 200);
            }
        }

        this.clearState =(callback)=> {
            this.setState({stats:{}, can2:{}, vehicle:{}}, callback);
        };

    }

    render() {
        return (
            <div className="CompactorView">
                <div className="cv-dial">
                    <div onClick={this.toggleSimulation} className={Dom.Class({active:this.isSimulating()}, "cvd-sim")}>SIM</div>
                    <div className="cvd-vbar">
                        <div className="cvdv-name">RPM</div>
                        <div className="cvdv-limit">10000</div>
                        <div className="cvdv-value">{this.state.can2.rpm}</div>
                        <div className="cvdv-total"></div>
                        <div className="cvdv-progress" style={{width:((this.state.can2.rpm || 0) / 10000 * 100) + '%'}}></div>
                    </div>
                    <div className="cvd-text"><span className="active">{this.state.vehicle.vehicleno}</span></div>
                    <div className="cvd-text -right">Ignition:{this.state.stats.ignitionstatus ? <span className="active">ON</span> : 'OFF'}{}</div>
                </div>
                <div className="cv-digitalSet">
                    <div className="cvd-item">
                        <div className="cvdi-body">
                            {this.state.can2.digital1 ? (<div className="cvdib-icon -active">ON</div>) : (<div className="cvdib-icon">OFF</div>)}
                            <div className="cvdib-name">Park Switch</div>
                        </div>
                    </div>
                    <div className="cvd-item">
                        <div className="cvdi-body">
                            {this.state.can2.digital2 ? (<div className="cvdib-icon -active">ON</div>) : (<div className="cvdib-icon">OFF</div>)}
                            <div className="cvdib-name">Oil Chock</div>
                        </div>
                    </div>
                    {/*<div className="cvd-item">*/}
                        {/*<div className="cvdi-body">*/}
                            {/*{this.state.can2.digital3 ? (<div className="cvdib-icon -active">ON</div>) : (<div className="cvdib-icon">OFF</div>)}*/}
                            {/*<div className="cvdib-name">D Input 3</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="cvd-item">*/}
                        {/*<div className="cvdi-body">*/}
                            {/*{this.state.can2.digital4 ? (<div className="cvdib-icon -active">ON</div>) : (<div className="cvdib-icon">OFF</div>)}*/}
                            {/*<div className="cvdib-name">D Input 4</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                </div>
                {/*<div className="cv-digitalSet">*/}
                    {/*<div className="cvd-item">*/}
                        {/*<div className="cvdi-body">*/}
                            {/*{this.state.can2.digital5 ? (<div className="cvdib-icon -active">ON</div>) : (<div className="cvdib-icon">OFF</div>)}*/}
                            {/*<div className="cvdib-name">D Input 5</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="cvd-item">*/}
                        {/*<div className="cvdi-body">*/}
                            {/*{this.state.can2.digital6 ? (<div className="cvdib-icon -active">ON</div>) : (<div className="cvdib-icon">OFF</div>)}*/}
                            {/*<div className="cvdib-name">D Input 6</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className="cv-analogSet">
                    <div className="cva-item">
                        <div className="cvai-body">
                            <div className="cvdib-value">{parseFloat(this.state.can2.analog1/1000).toFixed(2)}</div>
                            <div className="cvdib-name">Fuel</div>
                        </div>
                    </div>
                    <div className="cva-item">
                        <div className="cvai-body">
                            <div className="cvdib-value">{parseFloat(this.state.can2.analog2/1000).toFixed(2)}</div>
                            <div className="cvdib-name">Coolent</div>
                        </div>
                    </div>
                    <div className="cva-item">
                        <div className="cvai-body">
                            <div className="cvdib-value">{parseFloat(this.state.can2.analog3/1000).toFixed(2)}</div>
                            <div className="cvdib-name">Oil Pressure</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default CompactorView;